module.exports = __webpack_public_path__ + "img/sec4_2_.a425aa55.png";